import { render, staticRenderFns } from "./control-text.vue?vue&type=template&id=31b642b3"
import script from "./control-text.vue?vue&type=script&lang=js"
export * from "./control-text.vue?vue&type=script&lang=js"
import style0 from "./control-text.vue?vue&type=style&index=0&id=31b642b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports